import { ROUTES } from '@/router/routesEnum';
import axios from 'axios';
import { msalInstance } from 'vue-msal-browser';
import router from '../../router';
import store from '../store';
import { loginApiRequest } from '../utils/authConfig';
import LSService from './LocalStorageService';
const lsService = LSService.getService();

export const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API_URL,
});

export enum URLS {
  authenticate = '/api/Users/login2',
  account = '/api/Users',

  articleOdata = '/odata/articles',
  article = '/api/articles',
  articleMarkerOdata = '/odata/articleMarkers',
  articleMarker = '/api/articleMarkers',
  colorOdata = '/odata/colors',
  color = '/api/colors',

  exportArchiveOdata = '/odata/exportArchives',
  exportArchive = '/api/exportArchives',
  exportAutomaticOdata = '/odata/exportAutomatics',
  exportAutomatic = '/api/exportAutomatics',
  exportTemplateOdata = "/odata/exportTemplates",
  exportTemplate = "/api/exportTemplates",

  modelMarkerOdata = '/odata/modelMarkers',
  modelMarker = '/api/modelMarkers',

  saveListOdata = '/odata/saveLists',
  saveList = '/api/saveLists',

  responsibleOdata = '/odata/responsibles',
  responsible = '/api/responsibles',
  selectionOdata = '/odata/selections',
  selection = '/api/selections',

  users = 'api/users',
  usersOdata = 'odata/users',
  version = 'api/version', // for test
}

instance.interceptors.request.use(
  async (config: any) => {
    const account = msalInstance!.getAllAccounts()[0]; //.getAllAccounts()[0];
    // console.log('object :>> ', object);
    const msalResponse = await msalInstance?.acquireTokenSilent({
      ...loginApiRequest,
      account: account,
    });
    // const token = lsService.getAccessToken(); // don't need it for AZURE_AD // TODO: find a way to distinguish between Azure and usual login if needed or remove usual `login/pass` logic
    if (msalResponse && msalResponse.accessToken) {
      config.headers['Authorization'] = 'Bearer ' + msalResponse.accessToken;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error: any) => {
    // store.dispatch(`${URLS.users}/logout`);
    // router.push({
    //   name: ROUTES.login,
    //   params: { checkLogin: 'false' },
    // });
  }
);

instance.interceptors.response.use(
  (response: any) => {
    return response;
  },
  (error: any) => {
    const originalRequest = error.config;
    const refreshToken = lsService.getRefreshToken();
    if (error?.response?.status === 401 && !originalRequest._retry && refreshToken) {
      originalRequest._retry = true;

      const token = lsService.getAccessToken();
      return axios
        .post(
          `${URLS.users}/refreshtoken`,
          {
            refreshToken: refreshToken,
            accessToken: token,
          },
          {
            headers: {
              'Content-Type': 'application/json', // TODO: test if need this header (backend was set up to use JSON) + the same for `checkPasswordReset` action
            },
          }
        )
        .then((res: any) => {
          if (res.status === 201 || res.status == 200) {
            lsService.setToken(res.data);
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + lsService.getAccessToken();
            return axios(originalRequest);
          }

          return Promise.reject(error);
        });
    } else if (error?.response?.status === 401) {
      // NO refresh Token (not checked `Remember me` on Login) and JWT token expired

      store.commit('auth/resetAccount', undefined); // (EGRUP-270) need this reset to make `isLoggedIn` getter FALSE, otherwise we will see left drawer menu with icons and Username in top left corner
      // router.push({
      //   name: ROUTES.login,
      //   params: { checkLogin: 'false' },
      // });
      // tried to show `'Der Token ist abgelaufen. Bitte erneut anmelden',` snackbar but it always overriden by `"Laden der Daten fehlgeschlagen` red snackbar from `action.ts`
    }
    throw error;
  }
);
